import { createAsyncThunk } from "@reduxjs/toolkit";  
import { fetchRevenueList } from "src/services/revenue.service";

interface FetchRevenueListPayload {
  page: number;
  limit: number;
  fromDate?: string;
  toDate?: string;
}
export const doFetchRevenueList = createAsyncThunk(
  "revenue/fetchRevenueList",
  async (payload: FetchRevenueListPayload) => {
    try {
      const response = await fetchRevenueList(payload);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch revenue list";
      throw errorMessage;
    }
  },
);
